import { useContext } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import Header from './components/Header.js'
import Footer from './components/Footer.js'
import RegisterScreen from './screens/RegisterScreen.js'
import RegisterOwner from './screens/RegisterOwner.js'
import VerifyOwnerEmailScreen from './screens/VerifyOwnerEmailScreen.js'
import LoginScreen from './screens/LoginScreen.js'
import OwnerLoginScreen from './screens/OwnerLoginScreen.js'
import UserListScreen from './screens/UserListScreen.js'
import UserEditScreen from './screens/UserEditScreen.js'
import EmployeePasswordResetScreen from './screens/EmployeePasswordResetScreen.js'
import Home from './screens/Home.js'
import Inventory from './screens/Inventory.js'
import InventoryAdd from './screens/InventoryAdd.js'
import InventoryUpdate from './screens/InventoryUpdate.js'
import Settings from './screens/Settings.js'
import './bootstrap.min.css'
import './App.css'
// import './styles.css'
import ListItems from './screens/ListItems.js'
import ListManufacturers from './screens/ListManufacturers.js'
import Pointofsale from './screens/Pointofsale.js'
import InventoryReports from './screens/InventoryReports.js'
import LowInventory from './screens/LowInventory.js'
import SalesReport from './screens/SalesReport.js'
import SalesTransactions from './screens/SalesTransactions.js'
import StockMovements from './screens/StockMovements.js'
import Dashboard from './screens/Dashboard.js'
import AdminRegister from './screens/AdminRegister.js'
import ProfileScreen from './screens/ProfileScreen.js'
import OwnerProfileScreen from './screens/OwnerProfileScreen.js'
import ReturnsScreen from './screens/ReturnsScreen.js'
import { ThemeProvider, ThemeContext } from './components/ThemeContext.js'

// Component that defines the routes and applies the theme
const AppRoutes = () => {
  const { theme } = useContext(ThemeContext)
  const { pathname } = useLocation()
  const isReportPage =
    pathname.startsWith('/reports') || pathname.startsWith('/lowpage')

  return (
    <div
      style={{
        backgroundColor: theme.bg,
        color: theme.text,
        minHeight: '100vh'
      }}
    >
      <main className={theme}>
        <Container
          className={`py-3${isReportPage ? ' report-print-shell' : ''}`}
        >
          <Header />
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/register/' element={<RegisterScreen />} />
            <Route path='/owner/' element={<RegisterOwner />} />
            <Route path='/owner/register/' element={<RegisterOwner />} />
            <Route
              path='/owner/verify-email'
              element={<VerifyOwnerEmailScreen />}
            />
            <Route path='/owner/login/' element={<OwnerLoginScreen />} />
            <Route path='/login/' element={<LoginScreen />} />
            <Route path='/admin/userlist' element={<UserListScreen />} />
            <Route path='/admin/user/:id' element={<UserEditScreen />} />
            <Route
              path='/admin/user/:id/password'
              element={<EmployeePasswordResetScreen />}
            />
            <Route path='/profile' element={<ProfileScreen />} />
            <Route path='/owner/profile' element={<OwnerProfileScreen />} />
            <Route path='/admin/user/register/*' element={<AdminRegister />} />
            <Route path='/inventory/*' element={<Inventory />} />
            <Route path='/page/:pageNumber/*' element={<Inventory />} />
            <Route path='/search/:keyword/*' element={<Inventory />} />
            <Route path='/inventory/add' element={<InventoryAdd />} />
            <Route path='/inventory/edit/:id' element={<InventoryUpdate />} />
            <Route path='/settings/*' element={<Settings />} />
            <Route path='/items/*' element={<ListItems />} />
            <Route path='/pageitem/:pageNumberitem/*' element={<ListItems />} />
            <Route path='/name/*' element={<ListManufacturers />} />
            <Route
              path='/pagename/:pageNumbername'
              element={<ListManufacturers />}
            />
            <Route path='/pos/*' element={<Pointofsale />} />
            <Route path='/pagepos/:pageNumberpos/*' element={<Pointofsale />} />
            <Route path='/searchpos/:keyword/*' element={<Pointofsale />} />
            <Route path='/returns/*' element={<ReturnsScreen />} />
            <Route path='/reports/*' element={<InventoryReports />} />
            <Route path='/reports/sales' element={<SalesReport />} />
            <Route
              path='/reports/salesdetail'
              element={<SalesTransactions />}
            />
            <Route
              path='/reports/stockmovements'
              element={<StockMovements />}
            />
            <Route path='/reports/lowinventory/*' element={<LowInventory />} />
            <Route
              path='/lowpage/:lowpageNumber/*'
              element={<LowInventory />}
            />
            <Route path='*' element={<h1>404 Not Found</h1>} />
          </Routes>
          <Footer />
        </Container>
      </main>
    </div>
  )
}

// Main App component that wraps the application with the ThemeProvider
const App = () => {
  return (
    <ThemeProvider>
      <AppRoutes />
    </ThemeProvider>
  )
}

export default App
